var _path, _path2, _path3, _path4, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBgWaves(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 1305,
    viewBox: "0 0 1440 1305",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M654.753 776.864C286.707 687.725 58.2318 852.645 -10 946.247V1305C125.281 1228.05 445.778 1013.84 654.753 1050.5C1182 1143 1259.89 1026.83 1433 1016V579C1326.94 682.096 1022.8 866.002 654.753 776.864Z",
    fill: "url(#paint0_linear_266_3957)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M663.753 197.864C295.707 108.725 67.2318 273.645 -1 367.247V726C134.281 649.053 454.778 434.837 663.753 471.5C1191 564 1268.89 447.826 1442 437V0C1335.94 103.096 1031.8 287.002 663.753 197.864Z",
    fill: "url(#paint1_linear_266_3957)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M722.212 617.153C369.648 478.944 120.925 611.368 40.6338 694.857L-7.99987 1050.3C136.464 992.401 483.041 823.61 685.117 888.263C1194.96 1051.38 1287.87 946.842 1460.86 959.583L1520.1 526.618C1401.04 614.383 1074.78 755.362 722.212 617.153Z",
    fill: "url(#paint2_linear_266_3957)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M667.585 329.331C297.823 237.116 72.6683 424.054 6.31088 529.05L13.4527 926.777C147.18 839.041 463.361 595.8 673.032 632.694C1202.04 725.777 1277.6 595.583 1450.47 580.473L1441.77 95.9992C1337.77 212.199 1037.35 421.545 667.585 329.331Z",
    fill: "url(#paint3_linear_266_3957)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M711.871 490.671C338.274 305.616 52.9486 408.395 -43.0145 482.916L-130 837.438C33.9233 797.041 430.014 669.792 645.524 761.081C1189.26 991.403 1301.06 897.119 1489.58 932.031L1595.53 500.185C1456.64 574.12 1085.47 675.727 711.871 490.671Z",
    fill: "url(#paint4_linear_266_3957)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_266_3957",
    x1: 711.5,
    y1: 579,
    x2: 711.5,
    y2: 1305,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAF3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF4F4",
    stopOpacity: 0.22
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_266_3957",
    x1: 720.5,
    y1: 0,
    x2: 720.5,
    y2: 726,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAF3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF4F4",
    stopOpacity: 0.22
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_266_3957",
    x1: 805.259,
    y1: 428.809,
    x2: 706.84,
    y2: 1148.11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAF3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF4F4",
    stopOpacity: 0.22
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_266_3957",
    x1: 720.384,
    y1: 108.953,
    x2: 734.836,
    y2: 913.823,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAF4F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_266_3957",
    x1: 820.782,
    y1: 310.092,
    x2: 644.752,
    y2: 1027.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.789511,
    stopColor: "#FFEFEF",
    stopOpacity: 0.22
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgWaves);
export default __webpack_public_path__ + "static/media/bg_waves.caedfa246af096fd1700736e672e16f2.svg";
export { ForwardRef as ReactComponent };